// 🔧 promotion_publishing_service.js
// ✅ Purpose: Business service for publishing Promotion Posts
// ✅ Features:
// - Publishes scheduled Promotion Posts through backend Cloud Functions
// - Keeps React pages unaware of provider-specific APIs
// - Supports Facebook first
// - Future-ready for Instagram, LinkedIn, TikTok, and other providers
// - Updates are handled through secure callable functions
// - Fully block-commented for clarity and future devs

import { httpsCallable } from "firebase/functions";

import { functions } from "../../firebase";

/**
 * ============================================================================
 * Firebase Callable
 * ============================================================================
 */

const publishPromotionPostCallable =
  httpsCallable(
    functions,
    "publishPromotionPost"
  );

/**
 * ============================================================================
 * publishPromotionPost
 * ============================================================================
 *
 * Publishes a Promotion Post using the backend
 * Publishing Engine.
 *
 * MVP:
 * - Facebook provider shell.
 *
 * Future:
 * - Instagram
 * - LinkedIn
 * - TikTok
 * - Google Business
 */
export const publishPromotionPost = async ({
  postId,
}) => {
  if (!postId) {
    throw new Error(
      "Post ID is required."
    );
  }

  const response =
    await publishPromotionPostCallable({
      postId,
    });

  return response.data;
};